var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhDistDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H5C7.20914 0 9 1.79086 9 4V5C9 7.20914 7.20914 9 5 9H4C1.79086 9 0 7.20914 0 5V4ZM4 2C2.89543 2 2 2.89543 2 4V5C2 6.10457 2.89543 7 4 7H5C6.10457 7 7 6.10457 7 5V4C7 2.89543 6.10457 2 5 2H4ZM11 4C11 1.79086 12.7909 0 15 0H16C18.2091 0 20 1.79086 20 4V5C20 7.20914 18.2091 9 16 9H15C12.7909 9 11 7.20914 11 5V4ZM15 2C13.8954 2 13 2.89543 13 4V5C13 6.10457 13.8954 7 15 7H16C17.1046 7 18 6.10457 18 5V4C18 2.89543 17.1046 2 16 2H15ZM0 15C0 12.7909 1.79086 11 4 11H5C7.20914 11 9 12.7909 9 15V16C9 18.2091 7.20914 20 5 20H4C1.79086 20 0 18.2091 0 16V15ZM4 13C2.89543 13 2 13.8954 2 15V16C2 17.1046 2.89543 18 4 18H5C6.10457 18 7 17.1046 7 16V15C7 13.8954 6.10457 13 5 13H4ZM11 15C11 12.7909 12.7909 11 15 11H16C18.2091 11 20 12.7909 20 15V16C20 18.2091 18.2091 20 16 20H15C12.7909 20 11 18.2091 11 16V15ZM15 13C13.8954 13 13 13.8954 13 15V16C13 17.1046 13.8954 18 15 18H16C17.1046 18 18 17.1046 18 16V15C18 13.8954 17.1046 13 16 13H15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhDistDashboard);
export default __webpack_public_path__ + "static/media/wh_dist_dashboard.09e06ef8d0ffd13248f66f62bcada5b6.svg";
export { ForwardRef as ReactComponent };